import { ComponentType } from "react";
import { LANGUAGE } from "_constants";
import { ReactComponent as YellowCard } from "./assets/yellow-card.svg";
import { ReactComponent as RedCard } from "./assets/red-card.svg";
//import { ReactComponent as VarGoal } from "./assets/var-goal.svg";
//import { ReactComponent as VarPenalty } from "./assets/var-penalty.svg";
//import { ReactComponent as VarRedCard } from "./assets/var-red-card.svg";
import { ReactComponent as Substitution } from "./assets/substitution.svg";
import { ReactComponent as Penalty } from "./assets/penalty.svg";
import { ReactComponent as Injury } from "./assets/injury.svg";
import { ReactComponent as Offside } from "./assets/offside.svg";
import { ReactComponent as PenaltyGoal } from "./assets/penalty-shootout-goal.svg";
import { ReactComponent as PenaltyMissed } from "./assets/penalty-shootout-missed.svg";
import { ReactComponent as Goal } from "./assets/goal.svg";
import { ReactComponent as ThrowIn } from "./assets/throw-in.svg";
import { ReactComponent as Corner } from "./assets/corner.svg";
import { ReactComponent as ExtraTime } from "./assets/extra-time.svg";
import { ReactComponent as FullTime } from "./assets/full-time.svg";
import { ReactComponent as HalfTime } from "./assets/half-time.svg";
import { ReactComponent as PenaltyShootout } from "./assets/penalty-shootout-start.svg";
import { ReactComponent as VarInProcess } from "./assets/video-assistant-referees.svg";
import { ReactComponent as ShotOnTarget } from "./assets/shot-on-target.svg";
import { ReactComponent as ShotOffTarget } from "./assets/shot-off-target.svg";
import { ReactComponent as ShootPlayerRight } from "./assets/shoot-player-right.svg";
import { ReactComponent as ShootPlayerLeft } from "./assets/shoot-player-left.svg";
import { ReactComponent as KickOff } from "./assets/kick-off-soccer-player.svg";
import { ReactComponent as SecondHalfStarted } from "./assets/second-half-started.svg";
import { ReactComponent as ZonedThrow } from "./assets/zoned-throw.svg";
import { ReactComponent as VarCheckingGoal } from "./assets/var-checking-goal.svg";
import { ReactComponent as VarCheckingPenalty } from "./assets/var-checking-penalty.svg";
import { ReactComponent as VarCheckingRedCard } from "./assets/var-checking-red-card.svg";
//import { ReactComponent as VarDesicionGoal } from "./assets/var-desicion-goal.svg";
//import { ReactComponent as VarDesicionPenalty } from "./assets/var-desicion-penalty.svg";
//import { ReactComponent as VarDesicionRedCard } from "./assets/var-desicion-red-card.svg";
//import { ReactComponent as VarDesicionNoGoal } from "./assets/var-decision-no-goal.svg";
//import { ReactComponent as VarDesicionNoPenalty } from "./assets/var-decision-no-penalty.svg";

export const ICONS: Record<string, ComponentType<any>> = {
  "0008": PenaltyGoal,
  "0009": PenaltyMissed,
  "0021": Penalty,
  "1003": Goal,
  "1004": Corner,
  "1005": YellowCard,
  "1006": RedCard,
  "1007": ShootPlayerRight,
  "1008": Penalty,
  "1009": ShootPlayerRight,
  "1010": ShootPlayerLeft,
  "1011": ShotOnTarget,
  "1012": ShotOffTarget,
  "1013": Substitution,
  "1014": KickOff,
  "1015": HalfTime,
  "1016": SecondHalfStarted,
  "1017": FullTime,
  "1018": ExtraTime,
  "1019": HalfTime,
  "1020": ExtraTime,
  "1021": FullTime,
  "1022": PenaltyShootout,
  "1023": PenaltyMissed,
  "1024": ThrowIn,
  "1025": Injury,
  "1026": ExtraTime,
  "1234": Offside,
  "1236": ShootPlayerRight,
  "1237": ZonedThrow,
  "1238": Substitution,
  "1330": VarInProcess,
  "1331": VarCheckingRedCard,
  "1332": VarCheckingGoal,
  "1333": VarCheckingPenalty,
};

const MESSAGES_EN: Record<string, string> = {
  "0008": "Penalty Scored",
  "0009": "Penalty Missed",
  "0021": "Penalty",
  "1000": "Dangerous Attack",
  "1001": "Attack",
  "1002": "In Possession",
  "1003": "Goal",
  "1004": "Corner",
  "1005": "Yellow Card",
  "1006": "Red Card",
  "1007": "Goalkick",
  "1008": "Penalty",
  "1009": "Direct Freekick",
  "1010": "Simple Freekick",
  "1011": "Shot on goal",
  "1012": "Shot off goal",
  "1013": "Substitution",
  "1014": "Kick off",
  "1015": "Half Time",
  "1016": "Second Half",
  "1017": "Full Time",
  "1018": "Start Extra Time - 1st Half",
  "1019": "Extra Time Half Time",
  "1020": "Start Extra Time - 2nd Half",
  "1021": "End Of Extra Time",
  "1022": "Penalty Shootout",
  "1023": "Penalty Missed",
  "1024": "Throw In",
  "1025": "Injury",
  "1026": "Injury Time",
  "1234": "Offside",
  "1236": "Zoned Freekick",
  "1237": "Zoned Throw",
  "1238": "Substitution",
  "1300": "Take on Dangerous Attack",
  "1325": "?", // TODO - UNKNOWN DATA NEEDS TO CHECK
  "1330": "VAR In Progress",
  "1331": "VAR Reviewing Red Card",
  "1332": "VAR Reviewing Goal",
  "1333": "VAR Reviewing Penalty",
  "1901": "Corner Top",
  "1902": "Corner Bottom",
  "1931": "Freekick",
  "1932": "Freekick",
  "1933": "Freekick",
  "1934": "Freekick",
  "1935": "Freekick",
  "1936": "Freekick",
};

const MESSAGES_ALB: Record<string, string> = {
  "1000": "Dangerous Attack",
  "1001": "Attack",
  "1002": "In possession",
  "1004": "Corner",
  "1007": "Goalkick",
  "1008": "Penalty",
  "1009": "Direct Freekick",
  "1010": "Simple Freekick",
  "1024": "Throw",
  "0008": "Penalty Score",
  "0009": "Penalty Miss",
  "0021": "Penalty",
  "1003": "Goal",
  "1005": "Yellow Card",
  "1006": "Red Card",
  "1011": "Shot on Target",
  "1012": "Shot off Target",
  "1013": "Substitution",
  "1014": "Kick off",
  "1015": "Half time",
  "1016": "Second half",
  "1017": "Full time",
  "1018": "Start Extra Time - 1st Half",
  "1019": "Extra Time Half Time",
  "1020": "Start Extra Time - 2nd Half",
  "1021": "End Of Extra Time",
  "1022": "Penalty shoot out",
  "1023": "Penalty missed",
  "1025": "Injury",
  "1026": "Injury Time",
  "1237": "Zoned Throw",
  "1234": "Offside",
  "1238": "Substitution",
  "1332": "VAR Reviewing Goal",
  "1331": "VAR Reviewing Red Card",
  "1333": "VAR Reviewing Penalty",
  "1330": "VAR In Progress",
  "1901": "Corner",
  "1902": "Corner",
  "1931": "Freekick",
  "1932": "Freekick",
  "1933": "Freekick",
  "1934": "Freekick",
  "1935": "Freekick",
  "1936": "Freekick",
};

export const MESSAGES = {
  [LANGUAGE.ENGLISH]: MESSAGES_EN,
  [LANGUAGE.ALBANIAN]: MESSAGES_ALB,
};

export const SECONDARY_DICT: Record<number, Record<string, string>> = {
  [LANGUAGE.ALBANIAN]: {},
  [LANGUAGE.ENGLISH]: {},
};

/** Numeric feed codes used in `m[].mt` (use these numbers, not strings) */
export const FOOTBALL_EVENT_MT = {
  FIRST_HALF_END: 1, // "Score After First Half ..." (FH end)
  PERIOD_BUCKET: 10, // "00:00-09:59" vb. periyot blok satırları
  RACE_TO_CORNERS: 12, // "Race to N Corners"
  ASSIST: 237,
  SHOT_ON: 238,
  SHOT_OFF: 239,
  PENALTY_MISSED: 240, // missed penalty
  SUBSTITUTION: 246,
  OFFSIDE: 250,
  CORNER: 252,
  YELLOW_CARD: 253,
  RED_CARD: 254,
  GOAL: 255,
  GOAL_KICK: 1007, // goalkick
  THROW_IN: 1024, // throw-in
  FREE_KICK: 1931, // generic freekick
  VAR_REVIEW: 1330, // generic VAR review
} as const;

export const TYPE_BY_MT: Record<number, string> = {
  [FOOTBALL_EVENT_MT.ASSIST]: "assist",
  [FOOTBALL_EVENT_MT.GOAL]: "goal",
  [FOOTBALL_EVENT_MT.YELLOW_CARD]: "yellow_card",
  [FOOTBALL_EVENT_MT.RED_CARD]: "red_card",
  [FOOTBALL_EVENT_MT.CORNER]: "corner",
  [FOOTBALL_EVENT_MT.OFFSIDE]: "offside",
  [FOOTBALL_EVENT_MT.SUBSTITUTION]: "substitution",
  [FOOTBALL_EVENT_MT.SHOT_ON]: "shot_on",
  [FOOTBALL_EVENT_MT.SHOT_OFF]: "shot_off",
  [FOOTBALL_EVENT_MT.PENALTY_MISSED]: "penalty_missed",
  [FOOTBALL_EVENT_MT.FIRST_HALF_END]: "first_half_end",
  [FOOTBALL_EVENT_MT.PERIOD_BUCKET]: "period_bucket",
  [FOOTBALL_EVENT_MT.RACE_TO_CORNERS]: "race_to_corners",
  [FOOTBALL_EVENT_MT.FREE_KICK]: "freekick",
  [FOOTBALL_EVENT_MT.GOAL_KICK]: "goal_kick",
  [FOOTBALL_EVENT_MT.THROW_IN]: "throw_in",
  [FOOTBALL_EVENT_MT.VAR_REVIEW]: "var_review",
};

/** Regex-based fallback mapping when `mt` is missing.
 * Use with: iterate in order and pick the first match.
 */
export const TYPE_BY_TEXT: Array<[RegExp, string]> = [
  [/^(ft|full\s*time)\b|\bfull\s*time\b/i, "full_time"],
  [
    /\b(score\s+after\s+first\s+half|half\s*time|halftime|fh)\b/i,
    "first_half_end",
  ],
  [/\b(match\s*started|kick\s*off|kick-off|kickoff)\b/i, "whistle"],
  [/\b(second\s+half\s+started|2nd\s+half|second\s+half)\b/i, "whistle"],
  [/\b(missed\s+penalty|penalty\s+miss(?:ed)?)\b/i, "penalty_missed"],
  [/\brace\s+to\s+\d+\s+corners\b/i, "race_to_corners"],
  [/\bshot\s+on\s+target\b/i, "shot_on"],
  [/\bshot\s+off\s+target\b/i, "shot_off"],
  [/\boffside\b/i, "offside"],
  [/\bcorner\b/i, "corner"],
  [/\byellow\s*card\b/i, "yellow_card"],
  [/\bgoal\b/i, "goal"],
  [/\bassist?\b/i, "assist"],
  [/\bred\s*card\b/i, "red_card"],
  [/\bsubstitution\b/i, "substitution"],
  [/\bvar\b/i, "var_review"],
  [/\brace\s+to\s+\d+\s+corners\b/i, "race_to_corners"],
  [/\bpenalty\b/i, "penalty"],
  [/\binjury\b/i, "injury"],
  [/\bfree\s*kick\b/i, "freekick"],
  [/\bgoal\s*kick\b/i, "goal_kick"],
  [/\bthrow\b|\bthrow\s*in\b/i, "throw_in"],
  [/\b(score\s+after\s+first\s+half)\b/i, "first_half_end"],
  [/^\d{2}:\d{2}-\d{2}:\d{2}$/i, "period_bucket"],
];
